<template>
  <q-item class="q-ma-none q-pa-none">
    <q-item-section>
      <q-item-label class="my-input text-h5 text-weight-bold text-primary"
        >{{ data.extras.fullValue }}
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  name: 'SigleCard',
  props: {
    data: Object
  }
};
</script>

<style>
.my-input {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 10px;
  transition: border-color 0.3s;
  width: 95%;
}

.my-input:hover {
  cursor: default;
}
</style>
